var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
        [
          _c("Header", { attrs: { title: "WebRTC Video Test" } }),
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "pa-0",
                  attrs: { id: "main_content_minwidthset", cols: "12" },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0", attrs: { align: "start" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-7",
                          attrs: { id: "main_content", cols: "12" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0 mb-2",
                              attrs: {
                                id: "video_box",
                                cols: "8",
                                align: "center",
                              },
                            },
                            [
                              _c("video", {
                                staticClass:
                                  "video-js vjs-default-skin vjs-big-play-centered vjs-current-time vjs-control-bar",
                                staticStyle: {
                                  "object-fit": "fill",
                                  width: "100%",
                                  height: "400px",
                                  cursor: "default",
                                },
                                attrs: {
                                  id: "video0",
                                  width: "700",
                                  height: "400",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0",
                              attrs: {
                                id: "video_box",
                                cols: "8",
                                align: "center",
                              },
                            },
                            [
                              _c("video", {
                                staticClass:
                                  "video-js vjs-default-skin vjs-big-play-centered vjs-current-time vjs-control-bar",
                                staticStyle: {
                                  "object-fit": "fill",
                                  width: "100%",
                                  height: "400px",
                                  cursor: "default",
                                },
                                attrs: {
                                  id: "video1",
                                  width: "700",
                                  height: "400",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }